/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `high` - high
 * * `medium` - medium
 * * `low` - low
 * @export
 */
export const ConfidenceEnum = {
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;
export type ConfidenceEnum = (typeof ConfidenceEnum)[keyof typeof ConfidenceEnum];

export function instanceOfConfidenceEnum(value: any): boolean {
  for (const key in ConfidenceEnum) {
    if (Object.prototype.hasOwnProperty.call(ConfidenceEnum, key)) {
      if ((ConfidenceEnum as Record<string, ConfidenceEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ConfidenceEnumFromJSON(json: any): ConfidenceEnum {
  return ConfidenceEnumFromJSONTyped(json, false);
}

export function ConfidenceEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfidenceEnum {
  return json as ConfidenceEnum;
}

export function ConfidenceEnumToJSON(value?: ConfidenceEnum | null): any {
  return value as any;
}
